import { render, staticRenderFns } from "./CardSearchNfse.vue?vue&type=template&id=2bf1f276"
import script from "./CardSearchNfse.vue?vue&type=script&lang=js"
export * from "./CardSearchNfse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports